import { gql } from '@apollo/client'

export const CONFIRM_PRIMITIVE_RESERVATION = gql`
  mutation ConfirmPrimitiveReservation(
    $input: ConfirmPrimitiveReservationInput
  ) {
    confirmPrimitiveReservation(input: $input) {
      reservationNumber
      reservationInfo {
        paymentMethods
        detailedRoomStays {
          arrival
          departure
          roomTypeCode
          displayRoomTypeCode
          ratePlanCode
          displayRatePlanCode
          roomTypeName
          ratePlanName
          boardType
          guests {
            name
            email
            mobile
          }
          chargePerDays {
            date
            charge {
              itemName
              quantity
              discount
              rate
              total
              remark
            }
          }
          chargePerRoomStay {
            itemName
            quantity
            discount
            rate
            total
            remark
          }
          discount
          occupancy {
            adults
            extraBeds
          }
          totalChargePerRoomStay
          totalChargePerDay
          promotionDiscount
        }
        totalAmount {
          discount
          payable
        }
        expiresAt
        selectedRooms {
          roomTypeName
          ratePlanName
          occupancy {
            adults
            extraBeds
          }
          boardType
          checkIn
          checkOut
        }
        booker {
          firstName
          lastName
          email
          mobile
        }
        providerCode
        displayProviderCode
      }
      paymentInfo {
        walletID
        walletType
        isBilateral
        cashBalance
        remainingCreditBalance
        currency
        creditorID
      }
      billingSummary {
        roomsPrice {
          roomTypeName
          ratePlanCode
          displayRatePlanCode
          quantity
          price
        }
        subTotalPrice {
          subTotalBeforeDiscount
          discount
          additionalDiscount
          promotionDiscount
          subTotalAfterDiscount
        }
        taxAndFees
        totalPayable
        curruncy
      }
    }
  }
`
export const MAKE_PRIMITIVE_RESERVATION = gql`
  mutation MakePrimitiveReservation($input: MakePrimitiveReservationInput!) {
    makePrimitiveReservation(input: $input) {
      promotionApplication {
        state
        totalDiscountMinor
        currency
        applied {
          promotionId
          name
          discountType
          discountMinor
          currency
          priority
          stackable
          allocations {
            roomStayReference
            discountMinor
            currency
          }
        }
      }
      reservationNumber
      optionReserveMaxExpireTime
      isAuthorizedToDeclareOptionReserve
      isAutorizedToDeclareDiscount
      roomStays {
        arrival
        departure
        crsNumber
        roomStayReference
        roomTypeName
        roomTypeCode
        displayRoomTypeCode
        ratePlanName
        ratePlanCode
        displayRatePlanCode
        price {
          beforeDiscount {
            roomPrice
            extraBedPrice
            totalPrice
          }
          afterDiscount {
            roomPrice
            extraBedPrice
            totalPrice
          }
        }
        pricePerDay {
          date
          price {
            beforeDiscount {
              roomPrice
              extraBedPrice
              totalPrice
            }
            afterDiscount {
              roomPrice
              extraBedPrice
              totalPrice
            }
          }
        }
        occupancy {
          adults
          extraBeds
        }
        boardType
      }
      paymentInfo {
        walletID
        walletType
        isBilateral
        cashBalance
        remainingCreditBalance
        currency
        creditorID
      }
      providerCode
      displayProviderCode
      providerName
      rateGroupCode
      rateGroupName
      propertyCode
      displayPropertyCode
      propertyName
      expiresAt
      billingSummary {
        roomsPrice {
          roomTypeName
          ratePlanCode
          displayRatePlanCode
          quantity
          price
        }
        subTotalPrice {
          subTotalBeforeDiscount
          discount
          additionalDiscount
          promotionDiscount
          subTotalAfterDiscount
        }
        taxAndFees
        totalPayable
        curruncy
      }
      selectedRooms {
        roomTypeName
        ratePlanName
        boardType
        occupancy {
          adults
          extraBeds
        }
        checkIn
        checkOut
      }
      showReservationType
    }
  }
`
